module.exports = __webpack_public_path__ + "img/w-tools.24cb1e1e.png";